module.exports = __webpack_public_path__ + "img/open.0a1a7a2e.png";